export default __webpack_public_path__ + "static/media/Hero (2).299d8282.jpg";